export const ROUTER_INITIATED = 'ROUTER_INITIATED'

export default {
  [ROUTER_INITIATED] (state) {
    state.initiated = true
  }
}
